import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-976b60c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-admin-hub" }
const _hoisted_2 = { class: "nge-admin-modal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-admin-modal-title" }, "Delete this notification?", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-admin-modal-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-admin-modal-sub" }, " This removes it for every user and can't be undone. ", -1 /* HOISTED */))
const _hoisted_7 = { class: "nge-admin-modal-actions" }
const _hoisted_8 = {
  key: 1,
  class: "nge-admin-toast"
}
const _hoisted_9 = { class: "nge-admin-subtabs" }
const _hoisted_10 = {
  key: 2,
  class: "nge-admin-section"
}
const _hoisted_11 = { class: "nge-admin-block" }
const _hoisted_12 = { class: "nge-admin-label" }
const _hoisted_13 = {
  key: 0,
  class: "nge-admin-editing-banner"
}
const _hoisted_14 = { class: "nge-admin-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "All Users", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "group" }, "Group", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "user" }, "Specific User", -1 /* HOISTED */))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select group...", -1 /* HOISTED */))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "nge-admin-row nge-admin-row--dates" }
const _hoisted_22 = { class: "nge-admin-date-label" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Send at "),
  /*#__PURE__*/_createElementVNode("em", { class: "nge-admin-tz" }, "(ET)")
], -1 /* HOISTED */))
const _hoisted_24 = { class: "nge-admin-date-label" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Expires at "),
  /*#__PURE__*/_createElementVNode("em", { class: "nge-admin-tz" }, "(ET)")
], -1 /* HOISTED */))
const _hoisted_26 = {
  key: 1,
  class: "nge-admin-hint"
}
const _hoisted_27 = {
  key: 2,
  class: "nge-admin-hint"
}
const _hoisted_28 = { class: "nge-admin-row" }
const _hoisted_29 = { class: "nge-admin-check" }
const _hoisted_30 = {
  key: 0,
  class: "nge-admin-note-inline"
}
const _hoisted_31 = { class: "nge-admin-file-label" }
const _hoisted_32 = { class: "nge-admin-file-label nge-admin-file-label--icon" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-admin-hint" }, "Images up to 8 MB (PNG, JPEG, WebP, GIF). The feed always loads the small icon, not the full image.", -1 /* HOISTED */))
const _hoisted_34 = { class: "nge-admin-row" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { key: 3 }
const _hoisted_40 = {
  key: 3,
  class: "nge-admin-error"
}
const _hoisted_41 = {
  key: 4,
  class: "nge-admin-confirm"
}
const _hoisted_42 = { class: "nge-admin-block nge-admin-notif-filters" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Show", -1 /* HOISTED */))
const _hoisted_44 = { class: "nge-admin-filter-chips" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "nge-admin-filter-count" }
const _hoisted_47 = {
  key: 0,
  class: "nge-admin-block"
}
const _hoisted_48 = { class: "nge-admin-label" }
const _hoisted_49 = { class: "nge-admin-notif-info" }
const _hoisted_50 = { class: "nge-admin-notif-meta" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 1,
  class: "nge-admin-block"
}
const _hoisted_55 = { class: "nge-admin-label" }
const _hoisted_56 = { class: "nge-admin-notif-info" }
const _hoisted_57 = { class: "nge-admin-notif-meta" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 2,
  class: "nge-admin-block"
}
const _hoisted_62 = { class: "nge-admin-label" }
const _hoisted_63 = { class: "nge-admin-notif-info" }
const _hoisted_64 = { class: "nge-admin-notif-meta" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 3,
  class: "nge-admin-block"
}
const _hoisted_67 = {
  key: 3,
  class: "nge-admin-section"
}
const _hoisted_68 = { class: "nge-admin-block" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Create Group", -1 /* HOISTED */))
const _hoisted_70 = { class: "nge-admin-row" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = { class: "nge-admin-block" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Manage Groups", -1 /* HOISTED */))
const _hoisted_74 = { class: "nge-admin-group-list" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = {
  key: 0,
  class: "nge-admin-members"
}
const _hoisted_77 = { class: "nge-admin-row" }
const _hoisted_78 = {
  key: 0,
  class: "nge-admin-search-results"
}
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "nge-admin-member-list" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = {
  key: 0,
  class: "nge-admin-hint"
}
const _hoisted_83 = {
  key: 4,
  class: "nge-admin-section"
}
const _hoisted_84 = { class: "nge-admin-block" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Create Special Badge", -1 /* HOISTED */))
const _hoisted_86 = { class: "nge-admin-file-label" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { key: 2 }
const _hoisted_91 = {
  key: 0,
  class: "nge-admin-error"
}
const _hoisted_92 = {
  key: 0,
  class: "nge-admin-block"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, [
  /*#__PURE__*/_createTextVNode("Award Badge "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "nge-admin-hint",
    style: {"font-weight":"normal","margin-left":"6px"}
  }, "Click a badge to select it")
], -1 /* HOISTED */))
const _hoisted_94 = { class: "nge-admin-badge-grid" }
const _hoisted_95 = ["onClick", "title"]
const _hoisted_96 = ["src"]
const _hoisted_97 = { class: "nge-admin-badge-name" }
const _hoisted_98 = {
  key: 0,
  class: "nge-admin-success"
}
const _hoisted_99 = {
  key: 1,
  class: "nge-admin-award-section"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-admin-hint" }, "Award to individual user:", -1 /* HOISTED */))
const _hoisted_101 = { class: "nge-admin-row" }
const _hoisted_102 = {
  key: 0,
  class: "nge-admin-search-results"
}
const _hoisted_103 = ["onClick"]
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "nge-admin-hint",
  style: {"margin-top":"10px"}
}, "Or award to entire group:", -1 /* HOISTED */))
const _hoisted_105 = { class: "nge-admin-row" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "Select group...", -1 /* HOISTED */))
const _hoisted_107 = ["value"]
const _hoisted_108 = ["disabled"]
const _hoisted_109 = {
  key: 5,
  class: "nge-admin-section"
}
const _hoisted_110 = { class: "nge-admin-block" }
const _hoisted_111 = { class: "nge-triage-head" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Feedback Triage", -1 /* HOISTED */))
const _hoisted_113 = { class: "nge-triage-toggle" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show reviewed", -1 /* HOISTED */))
const _hoisted_115 = ["disabled"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-admin-hint" }, " The triage agent reads every incoming report and proposes an action. Nothing happens until you approve it here. Approving \"Send a message\" delivers the text below to the reporter as a notification. ", -1 /* HOISTED */))
const _hoisted_117 = {
  key: 0,
  class: "nge-admin-error"
}
const _hoisted_118 = {
  key: 1,
  class: "nge-admin-hint"
}
const _hoisted_119 = {
  key: 2,
  class: "nge-admin-hint"
}
const _hoisted_120 = { class: "nge-triage-meta" }
const _hoisted_121 = { class: "nge-triage-src" }
const _hoisted_122 = {
  key: 0,
  class: "nge-triage-status"
}
const _hoisted_123 = {
  key: 0,
  class: "nge-triage-excerpt"
}
const _hoisted_124 = {
  key: 1,
  class: "nge-triage-rationale"
}
const _hoisted_125 = ["onUpdate:modelValue"]
const _hoisted_126 = {
  key: 3,
  class: "nge-triage-rationale"
}
const _hoisted_127 = {
  key: 4,
  class: "nge-triage-spec"
}
const _hoisted_128 = {
  key: 0,
  class: "nge-triage-spec-label"
}
const _hoisted_129 = { class: "nge-triage-spec-text" }
const _hoisted_130 = {
  key: 5,
  class: "nge-triage-actions"
}
const _hoisted_131 = ["disabled", "onClick"]
const _hoisted_132 = ["disabled", "onClick"]
const _hoisted_133 = {
  key: 6,
  class: "nge-triage-actions"
}
const _hoisted_134 = ["disabled", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Delete is irreversible and removes the notification for EVERYONE, so\n         it takes a deliberate confirm, then acknowledges that it happened. "),
    ($setup.pendingDelete)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "nge-admin-modal-backdrop",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($setup.pendingDelete = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(" “" + _toDisplayString($setup.pendingDelete.title) + "”", 1 /* TEXT */),
              _hoisted_5,
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "nge-admin-modal-danger",
                onClick: $setup.confirmDelete
              }, "Delete"),
              _createElementVNode("button", {
                class: "nge-admin-modal-cancel",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.pendingDelete = null))
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.deleteDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createTextVNode(" ✓ " + _toDisplayString($setup.deleteDone) + " ", 1 /* TEXT */),
          _createElementVNode("button", {
            class: "nge-admin-confirm-x",
            onClick: _cache[2] || (_cache[2] = $event => ($setup.deleteDone = ''))
          }, "×")
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Sub-tabs "),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'notifications' }]),
        onClick: _cache[3] || (_cache[3] = $event => ($setup.adminSubTab = 'notifications'))
      }, "Notifications", 2 /* CLASS */),
      _createElementVNode("button", {
        class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'groups' }]),
        onClick: _cache[4] || (_cache[4] = $event => ($setup.adminSubTab = 'groups'))
      }, "Groups", 2 /* CLASS */),
      _createElementVNode("button", {
        class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'badges' }]),
        onClick: _cache[5] || (_cache[5] = $event => ($setup.adminSubTab = 'badges'))
      }, "Special Badges", 2 /* CLASS */),
      _createElementVNode("button", {
        class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'triage' }]),
        onClick: _cache[6] || (_cache[6] = $event => ($setup.adminSubTab = 'triage'))
      }, "Triage", 2 /* CLASS */)
    ]),
    _createCommentVNode(" ── Notifications ── "),
    ($setup.adminSubTab === 'notifications')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString($setup.editingId != null ? 'Editing Notification' : 'Send Notification'), 1 /* TEXT */),
            ($setup.editingId != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Editing an existing notification. Changes apply to everyone who can see it. "))
              : _createCommentVNode("v-if", true),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.notifTitle) = $event)),
              class: "nge-admin-input",
              placeholder: "Title"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.notifTitle]
            ]),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.notifBody) = $event)),
              class: "nge-admin-textarea",
              rows: "3",
              placeholder: "Message body..."
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.notifBody]
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.notifTargetType) = $event)),
                class: "nge-admin-select"
              }, _hoisted_18, 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.notifTargetType]
              ]),
              ($setup.notifTargetType === 'group')
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.notifTargetId) = $event)),
                    class: "nge-admin-select"
                  }, [
                    _hoisted_19,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.backend.groups, (g) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: g.id,
                        value: String(g.id)
                      }, _toDisplayString(g.name), 9 /* TEXT, PROPS */, _hoisted_20))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */)), [
                    [_vModelSelect, $setup.notifTargetId]
                  ])
                : _createCommentVNode("v-if", true),
              ($setup.notifTargetType === 'user')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.notifTargetId) = $event)),
                    class: "nge-admin-input nge-admin-input--sm",
                    placeholder: "User ID"
                  }, null, 512 /* NEED_PATCH */)), [
                    [_vModelText, $setup.notifTargetId]
                  ])
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  type: "datetime-local",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.notifSendAt) = $event)),
                  class: "nge-admin-date-input"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.notifSendAt]
                ])
              ]),
              _createElementVNode("label", _hoisted_24, [
                _hoisted_25,
                _withDirectives(_createElementVNode("input", {
                  type: "datetime-local",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($setup.notifExpiresAt) = $event)),
                  class: "nge-admin-date-input"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.notifExpiresAt]
                ])
              ])
            ]),
            ($setup.notifSendAt)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, " Sends " + _toDisplayString($setup.formatEt($setup.etNaiveToUtcIso($setup.notifSendAt))) + " — times are Eastern regardless of your own timezone. ", 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("p", _hoisted_27, "Leave \"Send at\" empty to send immediately")),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.notifPostToChat) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.notifPostToChat]
                ]),
                _createTextVNode(" Also post to chat")
              ]),
              ($setup.notifPostToChat && $setup.isScheduledForLater)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, " Chat post happens when it sends, not now. "))
                : _createCommentVNode("v-if", true),
              _createElementVNode("label", _hoisted_31, [
                _createElementVNode("input", {
                  type: "file",
                  accept: "image/png,image/jpeg,image/webp,image/gif",
                  onChange: $setup.onNotifImageChange,
                  class: "nge-admin-file-input"
                }, null, 32 /* HYDRATE_EVENTS */),
                _createTextVNode(" " + _toDisplayString($setup.notifImageFile ? $setup.notifImageFile.name : 'Attach image...'), 1 /* TEXT */)
              ]),
              _createCommentVNode(" Optional small icon. The feed renders a thumbnail per card, so a\n               purpose-made icon both looks better at 120px than an auto-crop of\n               the hero image and keeps the feed light. "),
              _createElementVNode("label", _hoisted_32, [
                _createElementVNode("input", {
                  type: "file",
                  accept: "image/png,image/jpeg,image/webp,image/gif",
                  onChange: $setup.onNotifIconChange,
                  class: "nge-admin-file-input"
                }, null, 32 /* HYDRATE_EVENTS */),
                _createTextVNode(" " + _toDisplayString($setup.notifIconFile ? $setup.notifIconFile.name : 'Feed icon (optional)...'), 1 /* TEXT */)
              ])
            ]),
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", {
                class: "nge-admin-primary-btn",
                disabled: $setup.notifSending || !$setup.notifTitle.trim() || !$setup.notifBody.trim(),
                onClick: $setup.sendNotification
              }, [
                ($setup.notifSent)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, "✓ Saved!"))
                  : ($setup.notifSending)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Saving..."))
                    : ($setup.editingId != null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Save Changes"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_39, "Send Notification"))
              ], 8 /* PROPS */, _hoisted_35),
              ($setup.editingId != null)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "nge-admin-cancel-btn",
                    onClick: $setup.cancelEdit
                  }, "Cancel edit"))
                : _createCommentVNode("v-if", true)
            ]),
            ($setup.notifError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, "⚠ " + _toDisplayString($setup.notifError), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Explicit confirmation of what actually happened, including the\n             scheduled time, rather than a transient \"Sent!\" on the button. "),
            ($setup.notifConfirm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createTextVNode(" ✓ " + _toDisplayString($setup.notifConfirm) + " ", 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "nge-admin-confirm-x",
                    onClick: _cache[15] || (_cache[15] = $event => ($setup.notifConfirm = ''))
                  }, "×")
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createCommentVNode(" Category filters. Auto-generated notifications (per-user badges,\n           weekly recaps, help replies) are off by default so the list shows the\n           admin's own broadcasts + weekly champions; toggle a chip to reveal a\n           category. Persisted per browser. "),
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.NOTIF_CATEGORIES, (cat) => {
                return _createElementVNode("button", {
                  key: cat.key,
                  class: _normalizeClass(["nge-admin-filter-chip", { 'nge-admin-filter-chip--on': $setup.visibleCategories.has(cat.key) }]),
                  onClick: $event => ($setup.toggleNotifCategory(cat.key))
                }, [
                  _createTextVNode(_toDisplayString(cat.label) + " ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_46, _toDisplayString($setup.categoryCount(cat.key)), 1 /* TEXT */)
                ], 10 /* CLASS, PROPS */, _hoisted_45)
              }), 64 /* STABLE_FRAGMENT */))
            ])
          ]),
          _createCommentVNode(" Notifications by lifecycle stage. All three come from ONE paginated\n           admin query (send_at DESC), so future-dated rows sort to the top and\n           the scheduled queue is always on the first page. Loading every\n           notification ever just to render this panel would get slow for no\n           benefit, hence \"Load more\". "),
          ($setup.scheduledNotifs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("label", _hoisted_48, "Scheduled (" + _toDisplayString($setup.scheduledNotifs.length) + ")", 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scheduledNotifs, (n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: n.id,
                    class: "nge-admin-notif-row nge-admin-notif-row--queued"
                  }, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("strong", null, _toDisplayString(n.title), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_50, [
                        _createTextVNode(_toDisplayString(n.target_type) + " · sends " + _toDisplayString($setup.formatEt(n.send_at)) + " ", 1 /* TEXT */),
                        (n.post_to_chat)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_51, " · posts to chat"))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "nge-admin-edit-btn",
                      onClick: $event => ($setup.startEdit(n)),
                      title: "Edit"
                    }, "✎", 8 /* PROPS */, _hoisted_52),
                    _createElementVNode("button", {
                      class: "nge-admin-delete-btn",
                      onClick: $event => ($setup.requestDelete(n)),
                      title: "Cancel this scheduled notification"
                    }, "×", 8 /* PROPS */, _hoisted_53)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.activeNotifs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("label", _hoisted_55, "Active (" + _toDisplayString($setup.activeNotifs.length) + ")", 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activeNotifs, (n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: n.id,
                    class: "nge-admin-notif-row nge-admin-notif-row--active"
                  }, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("strong", null, _toDisplayString(n.title), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_57, [
                        _createTextVNode(_toDisplayString(n.target_type) + " · sent " + _toDisplayString($setup.formatEt(n.send_at)) + " ", 1 /* TEXT */),
                        (n.expires_at)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_58, " · expires " + _toDisplayString($setup.formatEt(n.expires_at)), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "nge-admin-edit-btn",
                      onClick: $event => ($setup.startEdit(n)),
                      title: "Edit"
                    }, "✎", 8 /* PROPS */, _hoisted_59),
                    _createElementVNode("button", {
                      class: "nge-admin-delete-btn",
                      onClick: $event => ($setup.requestDelete(n)),
                      title: "Delete"
                    }, "×", 8 /* PROPS */, _hoisted_60)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Expired: no edit button. Editing something nobody can see any more\n           would just be misleading, so these are read-only apart from delete. "),
          ($setup.expiredNotifs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _createElementVNode("label", _hoisted_62, "Expired (" + _toDisplayString($setup.expiredNotifs.length) + ")", 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.expiredNotifs, (n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: n.id,
                    class: "nge-admin-notif-row nge-admin-notif-row--expired"
                  }, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("strong", null, _toDisplayString(n.title), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_64, _toDisplayString(n.target_type) + " · expired " + _toDisplayString($setup.formatEt(n.expires_at)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("button", {
                      class: "nge-admin-delete-btn",
                      onClick: $event => ($setup.requestDelete(n)),
                      title: "Delete"
                    }, "×", 8 /* PROPS */, _hoisted_65)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.backend.adminNotifHasMore)
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _createElementVNode("button", {
                  class: "nge-admin-more-btn",
                  onClick: _cache[16] || (_cache[16] = $event => ($setup.backend.loadAdminNotifications(true)))
                }, "Load more")
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ── Groups ── "),
    ($setup.adminSubTab === 'groups')
      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _createElementVNode("div", _hoisted_70, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (($setup.newGroupName) = $event)),
                class: "nge-admin-input",
                placeholder: "Group name (e.g. Scythes)"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.newGroupName]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($setup.newGroupColor) = $event)),
                type: "color",
                class: "nge-admin-color",
                title: "Group color"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.newGroupColor]
              ]),
              _createElementVNode("button", {
                class: "nge-admin-action-btn",
                onClick: $setup.createGroup,
                disabled: !$setup.newGroupName.trim()
              }, "Create", 8 /* PROPS */, _hoisted_71)
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("div", _hoisted_74, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.backend.groups, (g) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: g.id,
                  class: _normalizeClass(["nge-admin-group-chip", { 'nge-admin-group-chip--active': $setup.selectedGroupId === g.id }]),
                  style: _normalizeStyle({ borderColor: g.color }),
                  onClick: $event => ($setup.selectGroup(g.id))
                }, [
                  _createElementVNode("span", {
                    class: "nge-admin-group-dot",
                    style: _normalizeStyle({ background: g.color })
                  }, null, 4 /* STYLE */),
                  _createTextVNode(" " + _toDisplayString(g.name), 1 /* TEXT */)
                ], 14 /* CLASS, STYLE, PROPS */, _hoisted_75))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            ($setup.selectedGroupId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($setup.memberSearch) = $event)),
                      onInput: $setup.onMemberSearch,
                      class: "nge-admin-input",
                      placeholder: "Search users to add..."
                    }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                      [_vModelText, $setup.memberSearch]
                    ])
                  ]),
                  ($setup.memberSearchResults.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.memberSearchResults, (u) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: u.id,
                            class: "nge-admin-search-item",
                            onClick: $event => ($setup.addMember(u.id))
                          }, " + " + _toDisplayString(u.display_name || u.email), 9 /* TEXT, PROPS */, _hoisted_79))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_80, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupMembers, (m) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: m.user_id,
                        class: "nge-admin-member-row"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(m.display_name || m.email || m.user_id), 1 /* TEXT */),
                        _createElementVNode("button", {
                          class: "nge-admin-delete-btn",
                          onClick: $event => ($setup.removeMember(m.user_id))
                        }, "×", 8 /* PROPS */, _hoisted_81)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    ($setup.groupMembers.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, "No members yet."))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ── Special Badges ── "),
    ($setup.adminSubTab === 'badges')
      ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _hoisted_85,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($setup.badgeName) = $event)),
              class: "nge-admin-input",
              placeholder: "Badge name"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.badgeName]
            ]),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => (($setup.badgeDesc) = $event)),
              class: "nge-admin-textarea",
              rows: "2",
              placeholder: "Description..."
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.badgeDesc]
            ]),
            _createElementVNode("label", _hoisted_86, [
              _createElementVNode("input", {
                type: "file",
                accept: "image/*",
                onChange: $setup.onBadgeImageChange,
                class: "nge-admin-file-input"
              }, null, 32 /* HYDRATE_EVENTS */),
              _createTextVNode(" " + _toDisplayString($setup.badgeImageFile ? $setup.badgeImageFile.name : 'Choose badge image...'), 1 /* TEXT */)
            ]),
            _createElementVNode("button", {
              class: "nge-admin-primary-btn",
              disabled: $setup.badgeCreating || !$setup.badgeName.trim() || !$setup.badgeImageFile,
              onClick: $setup.createBadge
            }, [
              ($setup.badgeCreated)
                ? (_openBlock(), _createElementBlock("span", _hoisted_88, "✓ Created!"))
                : ($setup.badgeCreating)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_89, "Creating..."))
                  : (_openBlock(), _createElementBlock("span", _hoisted_90, "Create Badge"))
            ], 8 /* PROPS */, _hoisted_87),
            ($setup.badgeError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_91, "⚠ " + _toDisplayString($setup.badgeError), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          ($setup.backend.specialBadges.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                _hoisted_93,
                _createElementVNode("div", _hoisted_94, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.backend.specialBadges, (b) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: b.id,
                      class: _normalizeClass(["nge-admin-badge-card", { 'nge-admin-badge-card--selected': $setup.awardBadgeId === b.id }]),
                      onClick: $event => ($setup.selectBadgeForAward(b.id)),
                      title: b.description || b.name
                    }, [
                      (b.thumbnail_url || b.image_url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: b.thumbnail_url || b.image_url,
                            class: "nge-admin-badge-img"
                          }, null, 8 /* PROPS */, _hoisted_96))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_97, _toDisplayString(b.name), 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_95))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                ($setup.awardSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString($setup.awardSuccess), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.awardBadgeId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                      _hoisted_100,
                      _createElementVNode("div", _hoisted_101, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => (($setup.awardUserSearch) = $event)),
                          onInput: $setup.onAwardUserSearch,
                          class: "nge-admin-input",
                          placeholder: "Search by name or email..."
                        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                          [_vModelText, $setup.awardUserSearch]
                        ])
                      ]),
                      ($setup.awardUserResults.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.awardUserResults, (u) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: u.id,
                                class: "nge-admin-search-item",
                                onClick: $event => ($setup.awardToUser(u.id, u.display_name || u.email))
                              }, " Award to " + _toDisplayString(u.display_name || u.email), 9 /* TEXT, PROPS */, _hoisted_103))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      _hoisted_104,
                      _createElementVNode("div", _hoisted_105, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => (($setup.awardGroupId) = $event)),
                          class: "nge-admin-select"
                        }, [
                          _hoisted_106,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.backend.groups, (g) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: g.id,
                              value: g.id
                            }, _toDisplayString(g.name), 9 /* TEXT, PROPS */, _hoisted_107))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, $setup.awardGroupId]
                        ]),
                        _createElementVNode("button", {
                          class: "nge-admin-action-btn",
                          disabled: !$setup.awardGroupId,
                          onClick: $setup.awardToGroup
                        }, "Award to Group", 8 /* PROPS */, _hoisted_108)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ═══ TRIAGE (agent proposals awaiting human review) ═══ "),
    ($setup.adminSubTab === 'triage')
      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("div", _hoisted_111, [
              _hoisted_112,
              _createElementVNode("label", _hoisted_113, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => (($setup.triageShowReviewed) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.triageShowReviewed]
                ]),
                _hoisted_114
              ]),
              _createElementVNode("button", {
                class: "nge-admin-action-btn",
                onClick: $setup.loadTriage,
                disabled: $setup.triageLoading
              }, "↻ Refresh", 8 /* PROPS */, _hoisted_115)
            ]),
            _hoisted_116,
            ($setup.triageError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_117, "⚠ " + _toDisplayString($setup.triageError), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.triageLoading && !$setup.triageRows.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_118, "Loading…"))
              : (!$setup.triageRows.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_119, " No proposals waiting. The agent runs on a schedule; new feedback shows up here after its next pass. "))
                : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.triageRows, (row) => {
              return (_openBlock(), _createElementBlock("div", {
                key: row.id,
                class: "nge-triage-card"
              }, [
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["nge-triage-rec", `nge-triage-rec--${row.recommendation}`])
                  }, _toDisplayString($setup.TRIAGE_LABELS[row.recommendation]), 3 /* TEXT, CLASS */),
                  _createElementVNode("span", _hoisted_121, _toDisplayString(row.source.replace('_', ' ')), 1 /* TEXT */),
                  (row.status !== 'proposed')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_122, [
                        _createTextVNode(_toDisplayString(row.status), 1 /* TEXT */),
                        (row.reviewed_by)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" · " + _toDisplayString(row.reviewed_by), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                (row.source_excerpt)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_123, "\"" + _toDisplayString(row.source_excerpt) + "\"", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (row.rationale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_124, _toDisplayString(row.rationale), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (row.recommendation === 'message' && row.status === 'proposed')
                  ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      key: 2,
                      "onUpdate:modelValue": $event => (($setup.triageEdits[row.id]) = $event),
                      class: "nge-triage-message",
                      rows: "3",
                      onKeydown: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"])),
                      onKeyup: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"])),
                      onKeypress: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"]))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_125)), [
                      [_vModelText, $setup.triageEdits[row.id]]
                    ])
                  : (row.proposed_message)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_126, "💬 " + _toDisplayString(row.proposed_message), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                (row.spec)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parseSpec(row.spec), (line, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "nge-triage-spec-row"
                        }, [
                          (line.label)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_128, _toDisplayString(line.label), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("span", _hoisted_129, _toDisplayString(line.text), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                (row.status === 'proposed')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                      _createElementVNode("button", {
                        class: "nge-admin-primary-btn",
                        disabled: $setup.triageActing === row.id,
                        onClick: $event => ($setup.setTriageStatus(row, 'approved'))
                      }, _toDisplayString(row.recommendation === 'message' ? 'Approve + Send' : 'Approve'), 9 /* TEXT, PROPS */, _hoisted_131),
                      _createElementVNode("button", {
                        class: "nge-admin-action-btn",
                        disabled: $setup.triageActing === row.id,
                        onClick: $event => ($setup.setTriageStatus(row, 'dismissed'))
                      }, "Dismiss", 8 /* PROPS */, _hoisted_132)
                    ]))
                  : (row.status === 'approved')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                        _createElementVNode("button", {
                          class: "nge-admin-action-btn",
                          disabled: $setup.triageActing === row.id,
                          onClick: $event => ($setup.setTriageStatus(row, 'done'))
                        }, "Mark done", 8 /* PROPS */, _hoisted_134)
                      ]))
                    : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}